import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Calendar } from "lucide-react";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        api.get(`/blogs/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
    }, [slug]);

    if (error) return (
        <div className="pt-32 pb-20 container-vv text-center">
            <h1 className="font-serif text-3xl text-cream">Article not found</h1>
            <Link to="/blog" className="btn-outline-gold mt-6 inline-flex" data-testid="back-to-blog"><ArrowLeft className="h-4 w-4" /> Back to blog</Link>
        </div>
    );

    if (!post) return <div className="pt-32 container-vv text-cream-muted">Loading...</div>;

    return (
        <article data-testid="blog-post" className="pt-32 pb-20">
            <div className="container-vv max-w-4xl">
                <Link to="/blog" className="text-sm text-gold flex items-center gap-1 mb-6 hover:gap-2 transition-all"><ArrowLeft className="h-4 w-4" /> Back to all articles</Link>
                <div className="label-eyebrow">{post.category}</div>
                <h1 className="font-serif text-4xl md:text-5xl text-cream mt-4 leading-tight text-balance">{post.title}</h1>
                <div className="mt-4 text-xs text-cream-muted flex items-center gap-2"><Calendar className="h-3.5 w-3.5" /> {post.created_at}</div>

                {post.cover_url && (
                    <div className="mt-10 aspect-[16/9] rounded-2xl overflow-hidden border border-gold/20">
                        <img src={post.cover_url} alt={post.title} className="w-full h-full object-cover" />
                    </div>
                )}

                <div className="prose prose-invert mt-10 text-cream leading-relaxed text-base whitespace-pre-wrap max-w-none">
                    {post.content}
                </div>

                <div className="mt-16 card-luxe text-center">
                    <h3 className="font-serif text-2xl text-cream">Want a personalized reading?</h3>
                    <p className="mt-3 text-cream-muted">Book a 1-on-1 session with Dr. Tannu to apply these insights to your unique chart.</p>
                    <Link to="/booking" className="btn-gold mt-6 inline-flex" data-testid="blog-cta-book">Book a Consultation</Link>
                </div>
            </div>
        </article>
    );
}
